export enum EvidenceSensitivity {
  unknown = 'Unknown',
  low = 'Low',
  medium = 'Medium',
  high = 'High',
}
